import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	onClose: () => void;
};

export const SidebarContent = ({ onClose }: Props) => {
	const { formatMessage } = useIntl();

	/*
	 * Extra div wrapper required
	 * refer https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/business/shared/components/app-wrapper/src/ui/app-wrapper/sidebar-layout/styled.tsx#23
	 */
	return (
		<Box>
			<Box xcss={wrapperStyles}>
				<Flex justifyContent="space-between" alignItems="center">
					<Heading size="medium">{formatMessage(messages.heading)}</Heading>
					<IconButton
						appearance="subtle"
						icon={CrossIcon}
						label={formatMessage(messages.close)}
						isTooltipDisabled={false}
						onClick={onClose}
					/>
				</Flex>
				<p>{formatMessage(messages.info)}</p>
			</Box>
		</Box>
	);
};

const wrapperStyles = xcss({
	paddingTop: 'space.200',
	paddingLeft: 'space.250',
	paddingRight: 'space.250',
});
